module.exports = __webpack_public_path__ + "img/2.802d20bd.png";